import { render } from "./TipsIons.vue?vue&type=template&id=36b18eb2"
import script from "./TipsIons.vue?vue&type=script&lang=js"
export * from "./TipsIons.vue?vue&type=script&lang=js"
script.render = render

export default script